import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { THEME_SETTINGS } from "@theme-settings";
import { getRedirectOriginUrl } from "@utils/specific/capacitor/helpers";
import { useRootAppStore } from "@hooks";
import { Modal } from "@lib/modal";
import { Button } from "@components/buttons";
import { useFixBody } from "@state/hooks/shared";

export default observer(function ShareBetSlipModal() {
	const store = useRootAppStore();

	const { t } = useTranslation("mybets");
	useFixBody(
		false,
		store?.myBetsViewStore.shareBetSlipStore.isActive,
		"reuse-form"
	);

	if (!THEME_SETTINGS.features.isBetSlipShareEnabled) {
		return null;
	}

	if (store == null) {
		return null;
	}

	const sharedBetSlip =
		store.myBetsViewStore.shareBetSlipStore.activeSharedBetSlip;

	if (!store.myBetsViewStore.shareBetSlipStore.isActive || !sharedBetSlip) {
		return null;
	}

	return (
		<Modal>
			<div id="reuse-form" className="popup">
				<div className="popup__card popup__card--med">
					<div className="popup__header">
						<div className="popup__title">
							{t("SHARE.BUTTON_LABEL")}
						</div>
						<Button
							type="button"
							className="popup__close btn--square btn--square--xsml btn--ghost"
							iconOnly={true}
							iconClassName="u-icon--tny u-icon--close"
							onClick={() =>
								store.myBetsViewStore.shareBetSlipStore.hidePopup()
							}
							title={t("COMMON.CLOSE")}
						/>
					</div>
					<div className="popup__body popup--share__body">
						<div className="popup--share__row">
							<div className="popup--share__item">
								<a
									href={`https://api.whatsapp.com/send?text=${getRedirectOriginUrl(
										`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
									)}`}
									data-action="share/whatsapp/share"
									target="_blank"
									className="popup--share__btn--whatsapp btn btn--round btn--round--base btn--icon"
									onClick={() => {
										store.myBetsViewStore.shareBetSlipStore.insertSharedBetSlip();
									}}
								>
									<i className="u-icon u-icon--base u-icon--whatsapp u-color--core--snow" />
								</a>
								<span className="popup--share__label">
									WhatsApp
								</span>
							</div>
							<div className="popup--share__item">
								<a
									className="popup--share__btn--email btn btn--round btn--round--base btn--icon"
									href={`mailto:?subject=Bet%20slip&body=${getRedirectOriginUrl(
										`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
									)}`}
									title="Share by Email"
									onClick={() => {
										store.myBetsViewStore.shareBetSlipStore.insertSharedBetSlip();
									}}
								>
									<i className="u-icon u-icon--base u-icon--email--str u-color--core--snow" />
								</a>
								<span className="popup--share__label">
									Email
								</span>
							</div>
							{WEBPACK_IS_CHAT_AVAILABLE && (
								<div className="popup--share__item">
									<button
										className="popup--share__btn--chat btn btn--round btn--round--base btn--icon"
										title="Share to Chat"
										onClick={() => {
											store.chatViewStore.openBetSlipMessagePreview(
												sharedBetSlip
											);
											store.myBetsViewStore.shareBetSlipStore.hidePopup();
										}}
									>
										<i className="u-icon u-icon--base u-icon--chat--str u-color--core--snow"></i>
									</button>
									<span className="popup--share__label">
										Chat
									</span>
								</div>
							)}
						</div>
					</div>
					<div className="popup--share__footer">
						<div className="popup--share__copy">
							<i className="u-icon u-icon--base u-icon--hyperlink" />
							<span className="popup--share__copy__label">
								{getRedirectOriginUrl(
									`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
								)}
							</span>
							<button
								className="popup--share__copy__btn btn btn--sml btn--accent"
								type="button"
								onClick={() => {
									store.myBetsViewStore.shareBetSlipStore.copyLink();
								}}
							>
								{t("SHARE.COPY_LINK")}
							</button>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
});
